<template>
  <div class="search-input form-group" :class="[currentTheme, size]">
    <i class="icon icon-search ion-ios-search-strong"></i>
    <input ref="searchEl" autocomplete="off" class="form-control" :class="{ 'form-control-dark': currentTheme === 'theme-dark', 'form-control-sm': size === 'sm' }" v-model="innerValue" :placeholder="placeholder || 'Search'" type="text" @input="onInput" />
    <i class="icon icon-close ion-close-circled" @click.prevent="clear" v-if="value && value.length"></i>
  </div>
</template>

<script>
export default {
  name: 'search-input',
  props: ['value', 'theme', 'placeholder', 'size'],
  computed: {},
  data() {
    return {
      innerValue: null,
      currentTheme: null,
    }
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
    },
  },
  methods: {
    focus() {
      this.$refs.searchEl.focus()
    },
    onInput() {
      this.$emit('input', this.innerValue)
    },
    clear() {
      this.innerValue = null

      this.$emit('input', this.innerValue)
    },
  },
  created() {
    this.currentTheme = this.theme || 'theme-dark'

    this.innerValue = this.value
  },
}
</script>



// WEBPACK FOOTER //
// src/components/SearchInput.vue